import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import userReducer from './slice/user';
import staffReducer from './slice/staff';
import stageReducer from './slice/stage';
import panelReducer from './slice/panel';
import scoreReducer from './slice/score';
import merchantReducer from './slice/merchant';
import globalReducer from './slice/global';
import applyReducer from './slice/apply';
import tokenReducer from './slice/token';
import wsReducer from './slice/ws';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  blacklist: ['ws-connection'],
};

const appReducer = combineReducers({
  user: userReducer,
  staff: staffReducer,
  stage: stageReducer,
  panel: panelReducer,
  score: scoreReducer,
  merchant: merchantReducer,
  global: globalReducer,
  apply: applyReducer,
  token: tokenReducer,
  'ws-connection': wsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'USER/LOGOUT') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export { rootPersistConfig, rootReducer };
